// extracted by mini-css-extract-plugin
export default {"social_media":"Footer_social_media__Y34ci","copyright":"Footer_copyright__FJOSH"};